import React from 'react'
import clsx from 'clsx'
import { closePackageModal, openPackageModal } from 'lib/openPackageModal'
import PackageModal from './PackageModal'
import TimelineNode from '../TimelineNode'

const StepsTimeline = ({ steps }) => (
  <ul
    className="dome-list-no-style"
    style={{ marginTop: 12, padding: '12px 0', borderTop: '1px solid #F0F0F0', borderBottom: '1px solid #F0F0F0' }}
  >
    {steps.map((step, idx) => {
      const textClass = idx === 0 ? 'dome-p2 dome-color-darkest-grey' : 'dome-p2 dome-color-med-grey'
      const nodeColor = idx === 0 ? 'var(--sage)' : 'var(--lite-grey)'
      const edgeColor = idx === 0 ? 'var(--sage)' : 'var(--lite-grey)'

      return (
        <TimelineNode
          key={idx}
          label={step.title}
          textClass={textClass}
          nodeColor={nodeColor}
          edgeColor={edgeColor}
          isLast={idx === steps.length - 1}
        />
      )
    })}
  </ul>
)

const DEFAULT_PRIMARY_CLASSNAME = 'dome-btn dome-btn-base dome-btn-dark-green'
const DEFAULT_SECONDARY_CLASSNAME = 'dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-cancel'

// cta.className/cta.style pass straight through to the button, same as cta.label --
// producers own the exact look; these are only the fallbacks for callers that don't set one.
const CtaButton = ({ packageHashedId, cta, defaultClassName }) => {
  const onClick = () => {
    if (cta.modal) {
      openPackageModal(packageHashedId, cta.modal)
      return
    }
    if (cta.path) {
      window.location.href = cta.path
      return
    }
    // no explicit target (e.g. the ready-card "OK", or the default "close") -- just close this modal.
    closePackageModal()
  }

  return (
    <button type="button" className={cta.className || defaultClassName} style={cta.style} onClick={onClick}>
      {cta.label}
    </button>
  )
}

export default function NextStepsModal({
  packageHashedId,
  title,
  body,
  icon = 'fa-circle-check',
  steps = [],
  cta,
  secondaryCta,
}) {
  return (
    <PackageModal isOpen={true} onClose={closePackageModal}>
      <div style={{ width: 380 }}>
        <div className="dome-d-flex dome-flex-column dome-gap12">
          <i className={clsx('fa-thin dome-color-dark-green', icon)} style={{ fontSize: 42 }} />
          <span className="dome-h2 dome-color-dark-green" style={{ whiteSpace: 'pre-line' }}>
            {title}
          </span>
        </div>

        {body && (
          <p className="dome-p1 dome-color-dark-grey" style={{ marginTop: 18, marginBottom: 0 }}>
            {body}
          </p>
        )}

        {steps.length > 0 && <StepsTimeline steps={steps} />}

        <div
          className={clsx('dome-d-flex', secondaryCta ? 'dome-justify-between' : 'dome-justify-end')}
          style={{ marginTop: 24 }}
        >
          {secondaryCta && (
            <CtaButton
              packageHashedId={packageHashedId}
              cta={secondaryCta}
              defaultClassName={DEFAULT_SECONDARY_CLASSNAME}
            />
          )}
          <CtaButton
            packageHashedId={packageHashedId}
            cta={cta || { label: 'OK' }}
            defaultClassName={DEFAULT_PRIMARY_CLASSNAME}
          />
        </div>
      </div>
    </PackageModal>
  )
}
